
export const Action_SaveBanHang = "Action_SaveBanHang";
export const Action_SaveBanHangSuccess = "Action_SaveBanHangSuccess";
export const Action_SaveBanHangFailed = "Action_SaveBanHangFailed";

export const Action_GetBanHangPrint = "Action_GetBanHangPrint";
export const Action_GetBanHangPrintSuccess = "Action_GetBanHangPrintSuccess";


